import { VariantColor } from '@repo/toolkit/colors'
import { DateFormatter } from '@repo/toolkit/date'

import { LocaleKeys } from '../../../../locale/translation-types'
import useTranslate from '../../../hooks/use-translate'
import { CenterOlPayment } from '../../models/center-ol-payment/center-ol-payment'
import { CurrencyEnum } from '../common/currency.enum'

export enum CenterOlPaymentStatusEnum {
  CREATED = 'CREATED',
  EXPORTED = 'EXPORTED',
  VALIDATED = 'VALIDATED'
}

export const centerOlPaymentStatusEnumMapping: Record<
  CenterOlPaymentStatusEnum,
  { label: LocaleKeys; color: VariantColor }
> = {
  [CenterOlPaymentStatusEnum.CREATED]: {
    label: 'center.ol.payment.status.enum.CREATED',
    color: 'grey'
  },
  [CenterOlPaymentStatusEnum.EXPORTED]: {
    label: 'center.ol.payment.status.enum.EXPORTED',
    color: 'blue'
  },
  [CenterOlPaymentStatusEnum.VALIDATED]: {
    label: 'center.ol.payment.status.enum.VALIDATED',
    color: 'success'
  }
}

export function getCenterOlPaymentStatus(centerOlPayment: CenterOlPayment): {
  label: string
  color: VariantColor
} {
  const { status, exportedAt, validatedAt } = centerOlPayment
  const { t } = useTranslate()

  const label = t(centerOlPaymentStatusEnumMapping[status].label)
  const color: VariantColor = centerOlPaymentStatusEnumMapping[status].color

  switch (status) {
    case CenterOlPaymentStatusEnum.CREATED:
      return { color, label }

    case CenterOlPaymentStatusEnum.EXPORTED:
      return { color, label: `${label} - ${DateFormatter.DDMMYYYY(exportedAt)}` }

    case CenterOlPaymentStatusEnum.VALIDATED:
      return { color, label: `${label} - ${DateFormatter.DDMMYYYY(validatedAt)}` }

    default:
      return { color, label }
  }
}

// mirrors the backend validate rule: a payment must be exported before it can be validated,
// except USD payments which have no OL bank account so they can never be exported
export function canValidateCenterOlPayment({
  status,
  currency
}: Pick<CenterOlPayment, 'status' | 'currency'>): boolean {
  if (status === CenterOlPaymentStatusEnum.VALIDATED) return false
  return status === CenterOlPaymentStatusEnum.EXPORTED || currency === CurrencyEnum.USD
}
